import { Component } from '@angular/core';

@Component({
    selector: 'm4u-spin-loader',
    templateUrl: './spin-loader.component.html',
    styleUrls: ['./spin-loader.component.scss']
})
export class SpinLoaderComponent {
}
